// extracted by mini-css-extract-plugin
module.exports = {"service_hasProducts":"service_hasProducts-2sWZG","service_canAdd":"service_canAdd-TVOhY","service__totalPrice":"service__totalPrice-3WDHT"};